import { TbReportAnalytics } from "react-icons/tb";
import CadastroContainer from "../../components/CadastroContainer/CadastroContainer";
import "./Reports.css";
import { useParams } from "react-router-dom";
import { AccessModulesHistoric } from "./AccessModulesHistoric";
import PageTitle from "../../components/PageTitle/PageTitle";

export function Reports({ ...props }) {
   const { reportType } = useParams();

   return (
      <CadastroContainer>
         <PageTitle
            icon={<TbReportAnalytics />}
            title="Históricos"
         />
         <div>
            {reportType === 'historico-modulos-de-acessos' && <AccessModulesHistoric />}
         </div>
      </CadastroContainer>
   );
}